export default {"src":"/_next/static/media/fudge.0a9c7329.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};